import on from '../util/Elements/on'
import { breakpoints } from '../vars'

export default function (Site, $) {
	Site.widget('alert', {
		_create () {
			this.readValue()
		},

		readValue() {
			const alert = this.element;
			const unique = alert.data('cookie');
			const readValue = sessionStorage[unique];

			if (unique !== readValue) {
				this.alert()
			} else {
				alert.remove()
			}
		},

		alert () {
			const alert = this.element;
			alert.css({ opacity: '1' })

			const unique = alert.data('cookie');
			alert.find('.close').on('click', (e) => {
				sessionStorage[unique] = unique;
				alert.css({
					opacity: '0',
					transform: 'translateX(100%)'
				})
				setTimeout( () => { alert.remove() }, 200);
			})
		}
	}),

	Site.widget('alert-top', {
		_create () {
			this.calculate = on(
				$(window),
				'load resize',
				() => this.resize()
			)
		},

		_transitionIn () {
			this.resize()
		},

		_destroy() {
			this.calculate()
		},

		resize() {
			if (document.documentElement.clientWidth > breakpoints.sm.max) {
				var heroHeight = document.getElementsByClassName("page-hero")[0].clientHeight;
				this.element.css({
					top: heroHeight,
					opacity: 1
				});
			} else {
				this.element.removeAttr('style')
			}
		}
	})
}